<style>
    .ivu-table .demo-table-info-row td{
        background-color: #2db7f5;
        color: #fff;
    }
    .ivu-table .demo-table-error-row td{
        background-color: #ff6600;
        color: #fff;
    }
    .ivu-table .demo-table-price td{
        background-color: #187;
        color: #fff;
    }
    .ivu-table td.demo-table-info-column{
        background-color: #2db7f5;
        color: #fff;
    }
    .ivu-table .demo-table-info-cell-name {
        background-color: #2db7f5;
        color: #fff;
    }
    .ivu-table .demo-table-info-cell-age {
        background-color: #ff6600;
        color: #fff;
    }
    .ivu-table .demo-table-info-cell-address {
        background-color: #187;
        color: #fff;
    }
</style>
<template>
    <Row :gutter="10">
      <Card>
        <Row :gutter="24">
          <Col span="3">
            <Input v-model="approvalName" @on-change="init">
                <span slot="prepend">审批人</span>
            </Input>
          </Col>
          <Col span="3">
            <Button icon="md-download" :loading="exportLoading" @click="exportExcel">导出文件</Button>
          </Col>
          <Col span="3">
            <Button type="text" icon="md-refresh-circle" @click="init"></Button>
          </Col>
        </Row>
      </Card>
        <Card shadow>
            <p slot="title" style="text-align:center"><font size="4" color="#ff9900">部门软件使用统计</font></p>
            <Table :columns="columns" :row-class-name="rowClassName" :data="tableData" :height="scrollHeight"/>
        </Card>
    </Row>
</template>

<script>
import { getTableDataFromArray } from '@/libs/util'
import { getSoftwareAssetsWorkflow, getSoftwareAssetsPrice } from '@/api/cmdb'
import excel from '@/libs/excel'
export default {
  name: 'update_paste_page',
  components: {

  },
  data () {
    return {
      exportLoading: false,
      pasteDataArr: [],
      columns: [],
      excelColumns: [],
      excelData: [],
      tableData: [],
      validated: true,
      errorIndex: 0,
      scrollHeight: 0,
      approvalName: this.$store.state.user.name
    }
  },
  mounted () {
    this.scrollHeight = window.innerHeight - 150
    console.log(this.scrollHeight)
    this.init()
  },
  methods: {
    handleSuccess () {
      this.validated = true
    },
    handleError (index) {
      this.validated = false
      this.errorIndex = index
    },

    updateTableColumns () {
      let { columns, tableData } = getTableDataFromArray(this.pasteDataArr)
      this.columns = columns
      this.tableData = tableData
    },

    init () {
      this.pasteDataArr = []
      this.excelData = []
      getSoftwareAssetsPrice({ page: 1, size: 10000 }).then(rsp => {
        const { results } = rsp.data
        let columns = ['姓名']
        var endData = ['合计']
        let priceDict = {}
        let _excelEndData = { '姓名': '合计', '邮箱': '', '审批人': '' }
        this.excelColumns = ['姓名', '邮箱', '审批人']
        results.forEach(_t => {
          columns.push(_t.name)
          this.excelColumns.push(_t.name)
          endData.push(0)
          _excelEndData[_t.name] = 0
          priceDict[_t.id] = _t
        })
        this.pasteDataArr.push(columns)
        this.excelColumns.push('合计')
        getSoftwareAssetsWorkflow({ approval_name: this.approvalName, approval_status: '同意', page: 1, size: 100000 }).then(rsp => {
          const { results } = rsp.data
          results.forEach(_s => {
            let pasteData = []
            let softwareDict = {}
            let _excelData = {}

            pasteData.push(_s.name)
            _excelData['姓名'] = _s.name
            _excelData['邮箱'] = _s.mail
            _excelData['审批人'] = _s.approval_name
            // 去重：同一软件 ID 重复时只计一次，避免行合计虚高
            const idList = Array.from(new Set(_s.software_id_list || []))
            idList.forEach(_id => {
              const _software = priceDict[_id]
              if (_software) {
                softwareDict[_software.name] = Number(_software.price) || 0
              }
            })
            // 行合计按实际展示列汇总，保证与各软件列之和一致
            let _totalPrice = 0
            for (let i = 1; i < columns.length; i++) {
              const price = Object.prototype.hasOwnProperty.call(softwareDict, columns[i])
                ? softwareDict[columns[i]]
                : 0
              pasteData.push(price)
              endData[i] += price
              _excelData[columns[i]] = price
              _excelEndData[columns[i]] = endData[i]
              _totalPrice += price
            }
            pasteData.push(_totalPrice)
            this.pasteDataArr.push(pasteData)
            _excelData['合计'] = _totalPrice
            this.excelData.push(_excelData)
          })
          this.pasteDataArr[0].push('合计')
          const totalPrice = endData.slice(1).reduce((sum, n) => sum + n, 0)
          endData.push(totalPrice)
          _excelEndData['合计'] = totalPrice
          this.pasteDataArr.push(endData)
          this.excelData.push(_excelEndData)
          this.updateTableColumns()
        })
      })
    },

    rowClassName (row, index) {
      if (index === this.pasteDataArr.length - 1) {
        return 'demo-table-price'
      }
      return ''
    },

    exportExcel () {
      if (this.tableData.length) {
        this.exportLoading = true
        const params = {
          title: this.excelColumns,
          key: this.excelColumns,
          data: this.excelData,
          autoWidth: true,
          filename: '软件申请流程报表'
        }
        excel.export_array_to_excel(params)
        this.exportLoading = false
      } else {
        this.$Message.info('表格数据不能为空！')
      }
    }
  }
}
</script>

  <style lang="less">
  .update-paste{
    &-con{
      height: 350px;
    }
    &-btn-con{
      box-sizing: content-box;
      height: 30px;
      padding: 15px 0 5px;
    }
  }
  .paste-tip{
    color: #19be6b;
  }
  </style>
